<app-table [data]="roles"
           [config]="tableConfig"
           title="{{'admin.roles.table.title' | translate}}"
           [rowExpand]="false"
           [isLoading]="isLoading"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.roles.table.columns.roleId' | translate}}"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.roles.table.columns.roleName' | translate}}"
                      filter="true"
                      filterPlaceholder="{{'admin.roles.table.filter.placeholder.name' | translate}}"
                      sortable="true"
                      field="name">
    </app-table-column>
</app-table>
